import { Row, Col, Space } from "antd";
import { UploadOutlined, DeleteOutlined, ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";
import metaData from "../../data/metaData";

//
import UploadButton from "./UploadBtn";

const GalleryPlaceholder = ({ aspect = 16 / 9 }) => {
  return (
    <Row
      justify="center"
      align="middle"
      style={{
        minWidth: aspect == 1 ? "13rem" : "23rem",
        minHeight: "13rem",
        background: "var(--ion-color-step-50)",
      }}
    >
      <UploadOutlined style={{ fontSize: "1.25rem" }} />
      <div
        style={{
          marginTop: 8,
        }}
      ></div>
    </Row>
  );
};

const GalleryUploader = ({ gallery, aspect, MAX = 4, onFinish, onDelete, onMove }) => {
  const { t, i18n } = useTranslation();

  return (
    <div style={{ display: "flex", marginBottom: "24px" }}>
      {gallery?.length > 0 ? (
        <Row justify="start" align="middle">
          {gallery.map((e, i) => (
            <Col span={24} key={i}>
              <Row>
                <Col span={3}>
                  <Space direction="vertical" align="center" style={{ height: "100%" }}>
                    <DeleteOutlined
                      onClick={() => {
                        onDelete(i);
                      }}
                      style={{ color: "var(--ion-color-red-600)", fontSize: "1.25rem", marginBottom: "1rem" }}
                    />
                    {i === 0 ? null : (
                      <ArrowUpOutlined
                        onClick={() => {
                          onMove("up", i);
                        }}
                        style={{ color: "black", fontSize: "1.25rem" }}
                      />
                    )}
                    {i === gallery.length - 1 ? null : (
                      <ArrowDownOutlined
                        onClick={() => {
                          onMove("down", i);
                        }}
                        style={{ color: "black", fontSize: "1.25rem", marginBottom: "1rem" }}
                      />
                    )}
                  </Space>
                </Col>
                <Col span={21}>
                  <img
                    key={i}
                    style={{
                      objectFit: "cover",
                      minWidth: aspect == 1 ? "13rem" : "23rem",
                      minHeight: "13rem",
                      width: "100%",
                      backgroundColor: "var(--ion-color-step100)",
                      border: "1px solid lightgray",
                    }}
                    src={metaData.blobPreURL + "clientUpload-" + e + ".jpeg" + metaData.blobPostURL}
                  />
                </Col>
              </Row>
            </Col>
          ))}
        </Row>
      ) : (
        <GalleryPlaceholder aspect={aspect} />
      )}

      <div style={{ marginLeft: "1rem" }}>
        <UploadButton
          isDisable={gallery?.length === MAX}
          buttonLabel={gallery?.length === MAX ? `max ${MAX}` : t("ticket.Upload")}
          aspect={aspect}
          onFinish={onFinish} // Pass onFinish to handle the final file name
        />
      </div>
    </div>
  );
};

export default GalleryUploader;
